import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { Toaster } from '@web/components/Toaster';
import { NowProvider } from '@web/hooks/useNow';
import { createQueryClient } from '@web/lib/queryClient';

/**
 * Everything the tree needs, in the order it needs it.
 *
 * The client is created inside state rather than at module scope so a test can
 * mount two isolated apps in one process — and so a hot reload does not hand a
 * new tree a cache full of the old tree's promises.
 */
export function Providers({ children, client }: { children: ReactNode; client?: QueryClient }) {
  const [fallback] = useState(() => client ?? createQueryClient());

  return (
    <QueryClientProvider client={client ?? fallback}>
      <NowProvider>
        {children}
        <Toaster />
      </NowProvider>
    </QueryClientProvider>
  );
}
